import React from "react";
import { Link } from "react-router-dom";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Button } from "../components/ui/button";
import SafeImage from "../components/SafeImage";

const inTheApp = [
  { title: "Three readings", desc: "Soil moisture, air temperature, and humidity from an ESP8266 or ESP32 board." },
  { title: "History", desc: "Past readings on a chart, and a CSV download from the history page." },
  { title: "Alerts", desc: "A limit on temperature, humidity, or soil moisture. The app stores an alert when a reading crosses it." },
  { title: "The pump", desc: "On, off, a timer, or a soil-moisture rule, when the board has a relay." },
];

export default function About() {
  return (
    <PageShell>
      <PageHero
        eyebrow="About"
        title="Two founders."
        highlight="Noida."
        description="SmartFarm is an early irrigation app for terrace growers, nurseries, and small plots in India. Aryan Antal and Chetan Kumar are building it in Noida."
      />

      <PageSection variant="content">
        <div className="mx-auto max-w-7xl grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden bg-[var(--gradient-warm)]">
            <SafeImage
              src="/Images/farmer-tablet.jpg"
              alt="A grower looking at a phone"
              className="absolute inset-0 h-full w-full object-cover opacity-90"
              fallbackLabel="Our story"
            />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.18),transparent_30%)]" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-accent mb-3">Why it exists</div>
            <h2 className="font-display text-4xl sm:text-5xl text-balance">A sensor, a phone, and a pump.</h2>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              On a small plot the tap often stays open for a while, then someone checks the soil with a finger. SmartFarm puts a probe in that soil and shows the number on a phone.
            </p>
            <p className="mt-4 text-muted-foreground leading-relaxed">
              The same account can switch a pump, keep a history of readings, and raise an alert when a value crosses a limit. A weather forecast, a crop profile, and a camera are not in the product yet.
            </p>
          </div>
        </div>
      </PageSection>

      <PageSection tone="secondary">
        <div className="mx-auto max-w-3xl">
          <div className="mb-10">
            <div className="text-[10px] uppercase tracking-[0.22em] text-accent mb-3">In the app now</div>
            <h2 className="font-display text-4xl sm:text-5xl">What you can do after you sign in</h2>
          </div>
          <ul className="space-y-4">
            {inTheApp.map((item) => (
              <li key={item.title} className="rounded-2xl border border-border bg-card p-5">
                <h3 className="font-display text-2xl">{item.title}</h3>
                <p className="text-muted-foreground mt-2">{item.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </PageSection>

      <PageSection>
        <div className="mx-auto max-w-3xl">
          <div className="text-[10px] uppercase tracking-[0.22em] text-accent mb-3">Who builds it</div>
          <h2 className="font-display text-4xl sm:text-5xl">Aryan Antal and Chetan Kumar</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed max-w-xl">
            Aryan Antal is the founder. Chetan Kumar is the co-founder. Both are in Noida. Hardware and app questions go to the number on the contact page.
          </p>
          <Link to="/contact">
            <Button variant="accent" size="lg" className="mt-8">Contact</Button>
          </Link>
        </div>
      </PageSection>
    </PageShell>
  );
}
